/**
 * Wallet Pass Service
 * Issues and serves Apple Wallet and Google Wallet loyalty passes for Convercus programs. Internal administrators register programs, mint program API keys, maintain store locations, configure wallet design and levels, read adoption analytics and query the audit trail; customer-facing clients download a pass through the program-scoped download routes, and the wallets themselves keep it current through the Apple PassKit web service and the Google Wallet Objects callback. Every path below already carries the gateway base prefix `/wallet-pass-service`.
 *
 * The version of the OpenAPI document: 1.0.39938
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { CreateProgramLocationDto } from '../model/models';
import { InlineResponse2002 } from '../model/models';
import { InlineResponse2003 } from '../model/models';
import { InlineResponse401 } from '../model/models';
import { PatchProgramLocationDto } from '../model/models';
import { SetPassLocationsDto } from '../model/models';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import {
    LocationsServiceInterface,
    CreateLocationRequestParams,
    CreateLocationLegacyRequestParams,
    DeleteLocationRequestParams,
    DeleteLocationLegacyRequestParams,
    GetLocationRequestParams,
    GetLocationLegacyRequestParams,
    ListLocationsRequestParams,
    ListLocationsLegacyRequestParams,
    ListPassLocationsRequestParams,
    SetPassLocationsRequestParams,
    SetPassLocationsLegacyRequestParams,
    UpdateLocationRequestParams,
    UpdateLocationLegacyRequestParams
} from './locations.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class LocationsService implements LocationsServiceInterface {

    protected basePath = 'https://staging.convercus.io';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Create program location
     * Registers one store so passes in this program can point at it. &#x60;externalId&#x60; is the retailer\&#39;s own store id and must be unique within the program — a repeat is rejected with 409 rather than overwriting.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createLocation(requestParameters: CreateLocationRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<InlineResponse2002>;
    public createLocation(requestParameters: CreateLocationRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<InlineResponse2002>>;
    public createLocation(requestParameters: CreateLocationRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<InlineResponse2002>>;
    public createLocation(requestParameters: CreateLocationRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const createProgramLocationDto = requestParameters.createProgramLocationDto;
        if (createProgramLocationDto === null || createProgramLocationDto === undefined) {
            throw new Error('Required parameter createProgramLocationDto was null or undefined when calling createLocation.');
        }
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling createLocation.');
        }
        const xAdminKey = requestParameters.xAdminKey;

        let headers = this.defaultHeaders;
        if (xAdminKey !== undefined && xAdminKey !== null) {
            headers = headers.set('x-admin-key', String(xAdminKey));
        }

        let credential: string | undefined;
        // authentication (Admin) required
        credential = this.configuration.lookupCredential('Admin');
        if (credential) {
            headers = headers.set('x-admin-key', credential);
        }

        // authentication (Admin JWT) required
        credential = this.configuration.lookupCredential('Admin JWT');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.post<InlineResponse2002>(`${this.configuration.basePath}/wallet-pass-service/v1/admin/programs/${encodeURIComponent(String(programId))}/locations`,
            createProgramLocationDto,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create location legacy
     * Superseded by POST /v1/admin/programs/{programId}/locations. Registers one store so passes in this program can point at it. &#x60;externalId&#x60; is the retailer\&#39;s own store id and must be unique within the program — a repeat is rejected with 409 rather than overwriting. Blank &#x60;relevantText&#x60; and &#x60;address&#x60; are stored as null.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @deprecated
     */
    public createLocationLegacy(requestParameters: CreateLocationLegacyRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<InlineResponse2002>;
    public createLocationLegacy(requestParameters: CreateLocationLegacyRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<InlineResponse2002>>;
    public createLocationLegacy(requestParameters: CreateLocationLegacyRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<InlineResponse2002>>;
    public createLocationLegacy(requestParameters: CreateLocationLegacyRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const createProgramLocationDto = requestParameters.createProgramLocationDto;
        if (createProgramLocationDto === null || createProgramLocationDto === undefined) {
            throw new Error('Required parameter createProgramLocationDto was null or undefined when calling createLocationLegacy.');
        }
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling createLocationLegacy.');
        }
        const xAdminKey = requestParameters.xAdminKey;

        let headers = this.defaultHeaders;
        if (xAdminKey !== undefined && xAdminKey !== null) {
            headers = headers.set('x-admin-key', String(xAdminKey));
        }

        let credential: string | undefined;
        // authentication (Admin) required
        credential = this.configuration.lookupCredential('Admin');
        if (credential) {
            headers = headers.set('x-admin-key', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.post<InlineResponse2002>(`${this.configuration.basePath}/wallet-pass-service/admin/programs/${encodeURIComponent(String(programId))}/locations`,
            createProgramLocationDto,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete program location
     * Removes the store from the program. Existing pass-to-location links pointing at it are removed by cascade.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteLocation(requestParameters: DeleteLocationRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<any>;
    public deleteLocation(requestParameters: DeleteLocationRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<any>>;
    public deleteLocation(requestParameters: DeleteLocationRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<any>>;
    public deleteLocation(requestParameters: DeleteLocationRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling deleteLocation.');
        }
        const externalId = requestParameters.externalId;
        if (externalId === null || externalId === undefined) {
            throw new Error('Required parameter externalId was null or undefined when calling deleteLocation.');
        }
        const xAdminKey = requestParameters.xAdminKey;

        let headers = this.defaultHeaders;
        if (xAdminKey !== undefined && xAdminKey !== null) {
            headers = headers.set('x-admin-key', String(xAdminKey));
        }

        let credential: string | undefined;
        // authentication (Admin) required
        credential = this.configuration.lookupCredential('Admin');
        if (credential) {
            headers = headers.set('x-admin-key', credential);
        }

        // authentication (Admin JWT) required
        credential = this.configuration.lookupCredential('Admin JWT');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.delete<any>(`${this.configuration.basePath}/wallet-pass-service/v1/admin/programs/${encodeURIComponent(String(programId))}/locations/${encodeURIComponent(String(externalId))}`,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete location legacy
     * Superseded by DELETE /v1/admin/programs/{programId}/locations/{externalId}. Removes the store from the program. Existing pass-to-location links pointing at it are removed with it by the database cascade, so passes that showed this store stop doing so on their next refresh.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @deprecated
     */
    public deleteLocationLegacy(requestParameters: DeleteLocationLegacyRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<any>;
    public deleteLocationLegacy(requestParameters: DeleteLocationLegacyRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<any>>;
    public deleteLocationLegacy(requestParameters: DeleteLocationLegacyRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<any>>;
    public deleteLocationLegacy(requestParameters: DeleteLocationLegacyRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling deleteLocationLegacy.');
        }
        const externalId = requestParameters.externalId;
        if (externalId === null || externalId === undefined) {
            throw new Error('Required parameter externalId was null or undefined when calling deleteLocationLegacy.');
        }
        const xAdminKey = requestParameters.xAdminKey;

        let headers = this.defaultHeaders;
        if (xAdminKey !== undefined && xAdminKey !== null) {
            headers = headers.set('x-admin-key', String(xAdminKey));
        }

        let credential: string | undefined;
        // authentication (Admin) required
        credential = this.configuration.lookupCredential('Admin');
        if (credential) {
            headers = headers.set('x-admin-key', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.delete<any>(`${this.configuration.basePath}/wallet-pass-service/admin/programs/${encodeURIComponent(String(programId))}/locations/${encodeURIComponent(String(externalId))}`,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get program location
     * Looks a store up by the retailer\&#39;s own id rather than by this service\&#39;s UUID.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getLocation(requestParameters: GetLocationRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<InlineResponse2002>;
    public getLocation(requestParameters: GetLocationRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<InlineResponse2002>>;
    public getLocation(requestParameters: GetLocationRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<InlineResponse2002>>;
    public getLocation(requestParameters: GetLocationRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling getLocation.');
        }
        const externalId = requestParameters.externalId;
        if (externalId === null || externalId === undefined) {
            throw new Error('Required parameter externalId was null or undefined when calling getLocation.');
        }
        const xAdminKey = requestParameters.xAdminKey;

        let headers = this.defaultHeaders;
        if (xAdminKey !== undefined && xAdminKey !== null) {
            headers = headers.set('x-admin-key', String(xAdminKey));
        }

        let credential: string | undefined;
        // authentication (Admin) required
        credential = this.configuration.lookupCredential('Admin');
        if (credential) {
            headers = headers.set('x-admin-key', credential);
        }

        // authentication (Admin JWT) required
        credential = this.configuration.lookupCredential('Admin JWT');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<InlineResponse2002>(`${this.configuration.basePath}/wallet-pass-service/v1/admin/programs/${encodeURIComponent(String(programId))}/locations/${encodeURIComponent(String(externalId))}`,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get location legacy
     * Superseded by GET /v1/admin/programs/{programId}/locations/{externalId}. Looks a store up by the retailer\&#39;s own id rather than by this service\&#39;s UUID, so an integration can read back what it wrote without storing a second identifier.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @deprecated
     */
    public getLocationLegacy(requestParameters: GetLocationLegacyRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<InlineResponse2002>;
    public getLocationLegacy(requestParameters: GetLocationLegacyRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<InlineResponse2002>>;
    public getLocationLegacy(requestParameters: GetLocationLegacyRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<InlineResponse2002>>;
    public getLocationLegacy(requestParameters: GetLocationLegacyRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling getLocationLegacy.');
        }
        const externalId = requestParameters.externalId;
        if (externalId === null || externalId === undefined) {
            throw new Error('Required parameter externalId was null or undefined when calling getLocationLegacy.');
        }
        const xAdminKey = requestParameters.xAdminKey;

        let headers = this.defaultHeaders;
        if (xAdminKey !== undefined && xAdminKey !== null) {
            headers = headers.set('x-admin-key', String(xAdminKey));
        }

        let credential: string | undefined;
        // authentication (Admin) required
        credential = this.configuration.lookupCredential('Admin');
        if (credential) {
            headers = headers.set('x-admin-key', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<InlineResponse2002>(`${this.configuration.basePath}/wallet-pass-service/admin/programs/${encodeURIComponent(String(programId))}/locations/${encodeURIComponent(String(externalId))}`,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * List program locations
     * Returns every store registered for the program, ordered by &#x60;externalId&#x60;.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listLocations(requestParameters: ListLocationsRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Array<InlineResponse2002>>;
    public listLocations(requestParameters: ListLocationsRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Array<InlineResponse2002>>>;
    public listLocations(requestParameters: ListLocationsRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Array<InlineResponse2002>>>;
    public listLocations(requestParameters: ListLocationsRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling listLocations.');
        }
        const xAdminKey = requestParameters.xAdminKey;

        let headers = this.defaultHeaders;
        if (xAdminKey !== undefined && xAdminKey !== null) {
            headers = headers.set('x-admin-key', String(xAdminKey));
        }

        let credential: string | undefined;
        // authentication (Admin) required
        credential = this.configuration.lookupCredential('Admin');
        if (credential) {
            headers = headers.set('x-admin-key', credential);
        }

        // authentication (Admin JWT) required
        credential = this.configuration.lookupCredential('Admin JWT');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<Array<InlineResponse2002>>(`${this.configuration.basePath}/wallet-pass-service/v1/admin/programs/${encodeURIComponent(String(programId))}/locations`,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * List locations legacy
     * Superseded by GET /v1/admin/programs/{programId}/locations. Returns every store registered for the program, ordered by &#x60;externalId&#x60;. Use it to find the ids accepted by the pass-location replace call.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @deprecated
     */
    public listLocationsLegacy(requestParameters: ListLocationsLegacyRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Array<InlineResponse2002>>;
    public listLocationsLegacy(requestParameters: ListLocationsLegacyRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Array<InlineResponse2002>>>;
    public listLocationsLegacy(requestParameters: ListLocationsLegacyRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Array<InlineResponse2002>>>;
    public listLocationsLegacy(requestParameters: ListLocationsLegacyRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling listLocationsLegacy.');
        }
        const xAdminKey = requestParameters.xAdminKey;

        let headers = this.defaultHeaders;
        if (xAdminKey !== undefined && xAdminKey !== null) {
            headers = headers.set('x-admin-key', String(xAdminKey));
        }

        let credential: string | undefined;
        // authentication (Admin) required
        credential = this.configuration.lookupCredential('Admin');
        if (credential) {
            headers = headers.set('x-admin-key', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<Array<InlineResponse2002>>(`${this.configuration.basePath}/wallet-pass-service/admin/programs/${encodeURIComponent(String(programId))}/locations`,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * List pass location links
     * Resolves the account\&#39;s pass for the platform and returns the program locations currently linked to it (lock-screen relevant places). Uses the same account lookup as replace: a pass row is created if the account has none yet for that platform.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listPassLocations(requestParameters: ListPassLocationsRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Array<InlineResponse2002>>;
    public listPassLocations(requestParameters: ListPassLocationsRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Array<InlineResponse2002>>>;
    public listPassLocations(requestParameters: ListPassLocationsRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Array<InlineResponse2002>>>;
    public listPassLocations(requestParameters: ListPassLocationsRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling listPassLocations.');
        }
        const accountId = requestParameters.accountId;
        if (accountId === null || accountId === undefined) {
            throw new Error('Required parameter accountId was null or undefined when calling listPassLocations.');
        }
        const platform = requestParameters.platform;
        if (platform === null || platform === undefined) {
            throw new Error('Required parameter platform was null or undefined when calling listPassLocations.');
        }
        const xAdminKey = requestParameters.xAdminKey;
        const accountIdType = requestParameters.accountIdType;

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (accountId !== undefined && accountId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>accountId, 'accountId');
        }
        if (platform !== undefined && platform !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>platform, 'platform');
        }
        if (accountIdType !== undefined && accountIdType !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>accountIdType, 'accountIdType');
        }

        let headers = this.defaultHeaders;
        if (xAdminKey !== undefined && xAdminKey !== null) {
            headers = headers.set('x-admin-key', String(xAdminKey));
        }

        let credential: string | undefined;
        // authentication (Admin) required
        credential = this.configuration.lookupCredential('Admin');
        if (credential) {
            headers = headers.set('x-admin-key', credential);
        }

        // authentication (Admin JWT) required
        credential = this.configuration.lookupCredential('Admin JWT');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<Array<InlineResponse2002>>(`${this.configuration.basePath}/wallet-pass-service/v1/admin/programs/${encodeURIComponent(String(programId))}/passes/locations`,
            {
                params: queryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Replace pass location links
     * Replaces, in one transaction, the whole set of stores a customer\&#39;s pass shows on the lock screen. At most 10 locations, no duplicates, and every id must already exist in this program. The pass is looked up from the account and created if the account has none yet for the platform.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setPassLocations(requestParameters: SetPassLocationsRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Array<InlineResponse2003>>;
    public setPassLocations(requestParameters: SetPassLocationsRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Array<InlineResponse2003>>>;
    public setPassLocations(requestParameters: SetPassLocationsRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Array<InlineResponse2003>>>;
    public setPassLocations(requestParameters: SetPassLocationsRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const setPassLocationsDto = requestParameters.setPassLocationsDto;
        if (setPassLocationsDto === null || setPassLocationsDto === undefined) {
            throw new Error('Required parameter setPassLocationsDto was null or undefined when calling setPassLocations.');
        }
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling setPassLocations.');
        }
        const accountId = requestParameters.accountId;
        if (accountId === null || accountId === undefined) {
            throw new Error('Required parameter accountId was null or undefined when calling setPassLocations.');
        }
        const platform = requestParameters.platform;
        if (platform === null || platform === undefined) {
            throw new Error('Required parameter platform was null or undefined when calling setPassLocations.');
        }
        const xAdminKey = requestParameters.xAdminKey;
        const accountIdType = requestParameters.accountIdType;

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (accountId !== undefined && accountId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>accountId, 'accountId');
        }
        if (platform !== undefined && platform !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>platform, 'platform');
        }
        if (accountIdType !== undefined && accountIdType !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>accountIdType, 'accountIdType');
        }

        let headers = this.defaultHeaders;
        if (xAdminKey !== undefined && xAdminKey !== null) {
            headers = headers.set('x-admin-key', String(xAdminKey));
        }

        let credential: string | undefined;
        // authentication (Admin) required
        credential = this.configuration.lookupCredential('Admin');
        if (credential) {
            headers = headers.set('x-admin-key', credential);
        }

        // authentication (Admin JWT) required
        credential = this.configuration.lookupCredential('Admin JWT');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.put<Array<InlineResponse2003>>(`${this.configuration.basePath}/wallet-pass-service/v1/admin/programs/${encodeURIComponent(String(programId))}/passes/locations`,
            setPassLocationsDto,
            {
                params: queryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Replace pass locations legacy
     * Superseded by PUT /v1/admin/programs/{programId}/passes/locations. Replaces, in one transaction, the whole set of stores a customer\&#39;s pass shows on the lock screen; the previous links are deleted, and the order of &#x60;externalIds&#x60; becomes the display order. At most 10 locations, no duplicates, and every id must already exist in this pass\&#39;s program. The pass is looked up from the account, and created on the fly if the account has none yet for the platform.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @deprecated
     */
    public setPassLocationsLegacy(requestParameters: SetPassLocationsLegacyRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Array<InlineResponse2003>>;
    public setPassLocationsLegacy(requestParameters: SetPassLocationsLegacyRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Array<InlineResponse2003>>>;
    public setPassLocationsLegacy(requestParameters: SetPassLocationsLegacyRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Array<InlineResponse2003>>>;
    public setPassLocationsLegacy(requestParameters: SetPassLocationsLegacyRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const setPassLocationsDto = requestParameters.setPassLocationsDto;
        if (setPassLocationsDto === null || setPassLocationsDto === undefined) {
            throw new Error('Required parameter setPassLocationsDto was null or undefined when calling setPassLocationsLegacy.');
        }
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling setPassLocationsLegacy.');
        }
        const accountId = requestParameters.accountId;
        if (accountId === null || accountId === undefined) {
            throw new Error('Required parameter accountId was null or undefined when calling setPassLocationsLegacy.');
        }
        const platform = requestParameters.platform;
        if (platform === null || platform === undefined) {
            throw new Error('Required parameter platform was null or undefined when calling setPassLocationsLegacy.');
        }
        const xAdminKey = requestParameters.xAdminKey;
        const accountIdType = requestParameters.accountIdType;

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (accountId !== undefined && accountId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>accountId, 'accountId');
        }
        if (platform !== undefined && platform !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>platform, 'platform');
        }
        if (accountIdType !== undefined && accountIdType !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>accountIdType, 'accountIdType');
        }

        let headers = this.defaultHeaders;
        if (xAdminKey !== undefined && xAdminKey !== null) {
            headers = headers.set('x-admin-key', String(xAdminKey));
        }

        let credential: string | undefined;
        // authentication (Admin) required
        credential = this.configuration.lookupCredential('Admin');
        if (credential) {
            headers = headers.set('x-admin-key', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.put<Array<InlineResponse2003>>(`${this.configuration.basePath}/wallet-pass-service/admin/programs/${encodeURIComponent(String(programId))}/passes/locations`,
            setPassLocationsDto,
            {
                params: queryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update program location
     * Merges the supplied fields into the stored location. &#x60;externalId&#x60; itself cannot be changed here — delete and re-create instead.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateLocation(requestParameters: UpdateLocationRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<InlineResponse2002>;
    public updateLocation(requestParameters: UpdateLocationRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<InlineResponse2002>>;
    public updateLocation(requestParameters: UpdateLocationRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<InlineResponse2002>>;
    public updateLocation(requestParameters: UpdateLocationRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const patchProgramLocationDto = requestParameters.patchProgramLocationDto;
        if (patchProgramLocationDto === null || patchProgramLocationDto === undefined) {
            throw new Error('Required parameter patchProgramLocationDto was null or undefined when calling updateLocation.');
        }
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling updateLocation.');
        }
        const externalId = requestParameters.externalId;
        if (externalId === null || externalId === undefined) {
            throw new Error('Required parameter externalId was null or undefined when calling updateLocation.');
        }
        const xAdminKey = requestParameters.xAdminKey;

        let headers = this.defaultHeaders;
        if (xAdminKey !== undefined && xAdminKey !== null) {
            headers = headers.set('x-admin-key', String(xAdminKey));
        }

        let credential: string | undefined;
        // authentication (Admin) required
        credential = this.configuration.lookupCredential('Admin');
        if (credential) {
            headers = headers.set('x-admin-key', credential);
        }

        // authentication (Admin JWT) required
        credential = this.configuration.lookupCredential('Admin JWT');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.patch<InlineResponse2002>(`${this.configuration.basePath}/wallet-pass-service/v1/admin/programs/${encodeURIComponent(String(programId))}/locations/${encodeURIComponent(String(externalId))}`,
            patchProgramLocationDto,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update location legacy
     * Superseded by PATCH /v1/admin/programs/{programId}/locations/{externalId}. Merges the supplied fields into the stored location: an omitted property keeps its value, while &#x60;null&#x60; (or &#x60;\&quot;\&quot;&#x60; for the text fields) clears an optional one. &#x60;latitude&#x60; and &#x60;longitude&#x60; cannot be cleared. A body with no recognised field is accepted and returns the row unchanged. &#x60;externalId&#x60; itself cannot be changed here — delete and re-create instead.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @deprecated
     */
    public updateLocationLegacy(requestParameters: UpdateLocationLegacyRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<InlineResponse2002>;
    public updateLocationLegacy(requestParameters: UpdateLocationLegacyRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<InlineResponse2002>>;
    public updateLocationLegacy(requestParameters: UpdateLocationLegacyRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<InlineResponse2002>>;
    public updateLocationLegacy(requestParameters: UpdateLocationLegacyRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const patchProgramLocationDto = requestParameters.patchProgramLocationDto;
        if (patchProgramLocationDto === null || patchProgramLocationDto === undefined) {
            throw new Error('Required parameter patchProgramLocationDto was null or undefined when calling updateLocationLegacy.');
        }
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling updateLocationLegacy.');
        }
        const externalId = requestParameters.externalId;
        if (externalId === null || externalId === undefined) {
            throw new Error('Required parameter externalId was null or undefined when calling updateLocationLegacy.');
        }
        const xAdminKey = requestParameters.xAdminKey;

        let headers = this.defaultHeaders;
        if (xAdminKey !== undefined && xAdminKey !== null) {
            headers = headers.set('x-admin-key', String(xAdminKey));
        }

        let credential: string | undefined;
        // authentication (Admin) required
        credential = this.configuration.lookupCredential('Admin');
        if (credential) {
            headers = headers.set('x-admin-key', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.patch<InlineResponse2002>(`${this.configuration.basePath}/wallet-pass-service/admin/programs/${encodeURIComponent(String(programId))}/locations/${encodeURIComponent(String(externalId))}`,
            patchProgramLocationDto,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
